import { Type } from '@angular/core';
import { ProjectPolicyConfigComponent } from './project-policy-config.component';

export * from './project-policy-config.component'

export const PROJECT_POLICY_CONFIG_DIRECTIVES: Type<any>[] = [
    ProjectPolicyConfigComponent
];
